import React, { useEffect, useState } from "react";
import "./index.css";
// import {
//   initGoogleDriveClient,
//   signInToGoogle,
//   listFiles,
// } from "../../services/googleDriveService";
import { Content } from "antd/es/layout/layout";
import Files from "../../assets/img/files.png";
import HeaderDocumentAnalysis from "../../assets/img/documentAnalysis.png";
import { RcFile } from "antd/es/upload";
import {
  Button,
  message,
  Modal,
  Upload,
  Progress,
  Radio,
  Input,
  Form,
  Tooltip,
  Select,
  Spin,
} from "antd";
import {
  InboxOutlined,
  DownloadOutlined,
  ArrowLeftOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import { get, post } from "../../utils/apiUtils";
import useDrivePicker from "react-google-drive-picker";

const { Dragger } = Upload;
const { TextArea } = Input;
const { Option } = Select;

export type LanguageType = {
  id: string;
  name: string;
  code: string;
};

function GoogleDrive() {
  const [files, setFiles] = useState<{ id: string; name: string }[]>([]);
  const [fileList, setFileList] = useState<any>([]);
  const [uploadProgress, setUploadProgress] = useState<number>(0);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isDownloadModalVisible, setIsDownloadModalVisible] = useState(false); // For download modal
  const [processedFileURL, setProcessedFileURL] = useState<string>(""); // Store processed file URL
  const [language, setLanguage] = useState("");
  const [tokenizationType, setTokenizationType] = useState<string>(""); // For tokenization input
  const [stopWordsEnabled, setStopWordsEnabled] = useState<boolean>(false); // For stop words removal input
  const [supportedLanguages, setSupportedLanguages] = useState<LanguageType[]>(
    []
  );
  const [stemOrLemmatize, setStemOrLemmatize] = useState<string>(""); // New state to manage stemming or lemmatization
  const [selectedDriveFiles, setSelectedDriveFiles] = useState<any>([]);
  const [previewURL, setPreviewURL] = useState<string>("");
  const [isPreviewModalVisible, setIsPreviewModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  //   useEffect(() => {
  //     initGoogleDriveClient();
  //   }, []);

  //   const handleSignIn = async () => {
  //     try {
  //       //   await signInToGoogle();
  //       //   const response = await listFiles();
  //       //   const files = response.result.files;
  //       //   console.log("response in handleSignin", response);

  //       const filesResponse = await signInToGoogle();
  //       const files = filesResponse.result.files;
  //       if (files && files.length > 0) {
  //         const googleFiles = files.map((file: any) => ({
  //           uid: file.id,
  //           name: file.name,
  //           status: "done",
  //         }));
  //         setFiles(googleFiles); // Update state with files from Google Drive
  //         // Do not close the modal here; keep it open for the user to select a file
  //       } else {
  //         message.warning("No files found in Google Drive.");
  //       }
  //     } catch (error) {
  //       console.error("Error signing in:", error);
  //       message.error("Failed to sign in to Google Drive.");
  //     }
  //   };
  const createPreviewURL = (file: File) => {
    // This will not work directly for .docx previews; you can upload it to a temporary server if needed
    const fileURL = window.URL.createObjectURL(file);
    setPreviewURL(fileURL);
  };

  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { files } = event.target;
    if (files && files.length > 0) {
      const file = files[0];
      const newFile = {
        uid: file.name,
        name: file.name,
        status: "done",
        originFileObj: file,
      };
      setFileList([newFile]);
      createPreviewURL(file);
      handleModalCancel();
    }
  };
  // const handleFileUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   if (e.target.files && e.target.files.length > 0) {
  //     const selectedFile = e.target.files[0];
  //     const newFile = {
  //       uid: selectedFile.name,
  //       name: selectedFile.name,
  //       status: "done",
  //     };
  //     setFileList([...fileList, newFile]);
  //     createPreviewURL(selectedFile);
  //     handleModalCancel();
  //   }
  // };

  console.log("file listtt;:", fileList);

  const handleOpenPreviewModal = () => {
    if (fileList.length === 0) {
      message.error("No file to preview");
      return;
    }

    const selectedFile = fileList[0];

    if (selectedFile.url) {
      // Google Drive file, use its embed URL for preview
      setPreviewURL(
        `https://docs.google.com/document/d/${selectedFile.uid}/preview`
      );
    }

    // Open preview modal
    setIsPreviewModalVisible(true);
  };

  const handlePreviewModalCancel = () => {
    setIsPreviewModalVisible(false);
  };

  // Handling the file and form data submission to /preprocess endpoint
  const handleProcessClick = async () => {
    setLoading(true);
    const formData = new FormData();

    if (fileList.length === 0) {
      message.error("No file selected");
      setLoading(false);
      return;
    }

    // Append file and other form data to formData
    // formData.append("file", fileList[0].originFileObj); // Assuming the file is first in the list

    const selectedFile = fileList[0];

    if (selectedFile.url) {
      formData.append("google_drive_file_id", selectedFile.uid);
      formData.append("file", "");
    } else {
      formData.append("file", selectedFile.originFileObj);
      formData.append("google_drive_file_id", "");
    }

    formData.append(
      "tokenize",
      tokenizationType === "custom" ? "false" : "true"
    );
    formData.append("tokenize_by", tokenizationType); // 'word', 'sentence', or 'custom'
    formData.append(
      "custom_delim",
      tokenizationType === "custom" ? "custom_value_here" : ""
    ); // Custom delimiter
    formData.append("stem", "true"); // For stemming
    formData.append("lemmatize", "false"); // If lemmatization is not enabled
    formData.append("remove_stopwords", stopWordsEnabled ? "true" : "false");
    formData.append("language", language);

    try {
      const response = await post<any>("preprocess", formData, {
        headers: {
          "Content-Type": "multipart/form-data", // Set the correct content type for multipart form data
        },
        responseType: "blob", // Important for file download
      });

      if (!response || !response.data) {
        throw new Error("Failed to process");
      }

      // Get the file download URL from the response
      //   const fileURL = window.URL.createObjectURL(new Blob([response.data]));
      //   setProcessedFileURL(fileURL);
      const fileURL = window.URL.createObjectURL(
        new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        })
      );
      setProcessedFileURL(fileURL);
      setIsDownloadModalVisible(true); // Show the download modal
      message.success("File processed successfully");
    } catch (error: any) {
      message.error(`Error processing file: ${error.message}`);
    }
  };

  const handleFileChange = ({ file, fileList }: any) => {
    const newFileList = fileList.map((file: any) => ({
      uid: file.uid,
      name: file.name,
      status: file.status,
      originFileObj: file.originFileObj || file,
    }));
    setFileList(newFileList);
  };

  // const handleFileChange = (info: any) => {
  //   let fileList = [...info.fileList];
  //   if (fileList.length > 1) {
  //     fileList = fileList.slice(-1); // Only allow one file to be uploaded at a time
  //   }

  //   if (info.event) {
  //     const percentCompleted = Math.round(
  //       (info.event.loaded * 100) / info.event.total
  //     );
  //     setUploadProgress(percentCompleted);
  //   }
  //   setFileList(fileList);
  // };

  const handleCustomRequest = ({
    file,
    onSuccess,
    onError,
    onProgress,
  }: any) => {
    const xhr = new XMLHttpRequest();
    xhr.open("POST", "/upload");
    xhr.upload.onprogress = (event) => {
      if (event.lengthComputable) {
        const percentCompleted = Math.round((event.loaded * 100) / event.total);
        onProgress({ percent: percentCompleted });
        setUploadProgress(percentCompleted);
      }
    };
    xhr.onload = () => {
      if (xhr.status === 200) {
        onSuccess(xhr.response);
      } else {
        onError(new Error("Failed to upload"));
      }
    };
    xhr.onerror = () => {
      onError(new Error("Network Error"));
    };
    const formData = new FormData();
    formData.append("file", file);
    xhr.send(formData);
  };

  // const handleCustomRequest = ({
  //   file,
  //   onSuccess,
  //   onError,
  //   onProgress,
  // }: any) => {
  //   const xhr = new XMLHttpRequest();
  //   xhr.open("POST", "/upload");

  //   xhr.upload.onprogress = (event) => {
  //     if (event.lengthComputable) {
  //       const percentCompleted = Math.round((event.loaded * 100) / event.total);
  //       onProgress({ percent: percentCompleted });
  //       setUploadProgress(percentCompleted);
  //     }
  //   };

  //   xhr.onload = () => {
  //     if (xhr.status === 200) {
  //       onSuccess(xhr.response);
  //     } else {
  //       onError(new Error("Failed to upload"));
  //     }
  //   };

  //   xhr.onerror = () => {
  //     onError(new Error("Network Error"));
  //   };

  //   const formData = new FormData();
  //   formData.append("file", file);
  //   xhr.send(formData);
  // };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleModalCancel = () => {
    setIsModalVisible(false);
  };

  const handleDownloadModalCancel = () => {
    setIsDownloadModalVisible(false);
    setLoading(false);
  };

  useEffect(() => {
    // Fetch the supported languages from the endpoint when the component mounts
    const fetchSupportedLanguages = async () => {
      try {
        const response = await get<any>("languages/", {});
        setSupportedLanguages(response.data as LanguageType[]);
      } catch (error) {
        console.error(
          "There was an error fetching the supported languages:",
          error
        );
      }
    };

    fetchSupportedLanguages();
  }, []);

  const handleLanguageChange = (value: string) => {
    const selectedLanguage = supportedLanguages.find(
      (lang: any) => lang.code === value
    );
    if (selectedLanguage) {
      setLanguage(selectedLanguage.id); // Store the language ID when the language is changed
    }
  };

  const [openPicker, authResponse] = useDrivePicker();
  // const customViewsArray = [new google.picker.DocsView()]; // custom view
  const handleOpenPicker = async () => {
    const CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || "ID_JUYT";
    const CLIENT_SECRET = process.env.REACT_APP_GOOGLE_CLIENT_SECRET;
    const API_KEY = process.env.REACT_APP_API_KEY || "";

    // let token = await signInToGoogle();

    // console.log("token", token);

    openPicker({
      clientId: CLIENT_ID,
      developerKey: API_KEY,
      viewId: "DOCS",
      //   token: token, // pass oauth token in case you already have one
      showUploadView: true,
      showUploadFolders: true,
      supportDrives: true,
      multiselect: false,
      // customViews: customViewsArray, // custom view
      callbackFunction: (data) => {
        if (data.action === "picked") {
          const selectedGoogleDriveFile = {
            uid: data.docs[0].id, // Use the Google Drive file ID as a unique identifier
            name: data.docs[0].name, // Display name
            status: "done", // Mark it as done to show in the list
            url: data.docs[0].url, // Use this URL to link to the file if needed
          };

          // Replace the current file list with the selected Google Drive file
          setFileList([selectedGoogleDriveFile]); // Only allow one file at a time
          handleModalCancel();
        } else {
          console.log("User clicked cancel/close button");
        }
      },
    });
  };

  // const handleCancel = () => {
  //   setFileList([]);
  //   setTokenizationType("");
  //   setStopWordsEnabled(false);
  //   setLanguage("");
  //   setLoading(false);
  // };
  const handleCancel = () => {
    setFileList([]);
    setTokenizationType("");
    setStopWordsEnabled(false);
    setUploadProgress(0);
    setStemOrLemmatize("");
    setLoading(false);
  };
  return (
    <div className="user-management-layout" style={{ marginLeft: 0 }}>
      <Content className="content-styles">
        <div className="header-image">
          <img
            src={HeaderDocumentAnalysis}
            alt="document analysis"
            style={{ width: "100%" }}
          />
        </div>

        <div className="card">
          <div className="upload-document-style">
            <h2>Upload your document here</h2>

            <div onClick={showModal} style={{ zIndex: 9999 }}>
              <div style={{ zIndex: 9999 }}>
                {/* <Button
                  type="primary"
                  onClick={showModal}
                  style={{ marginBottom: "20px" }}
                >
                  Zgjidh një file nga Google Drive ose kompjuteri
                </Button> */}

                <div style={{ zIndex: 9999 }}>
                  <div
                    onClick={(e) => {
                      e.preventDefault();
                      showModal();
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <Dragger
                      name="file"
                      multiple={false}
                      // beforeUpload={(file: any) => {
                      //   const isSupported = true;
                      //   if (!isSupported) {
                      //     message.error(`${file.name} is not a valid file.`);
                      //     return Upload.LIST_IGNORE;
                      //   }
                      //   return false;
                      // }}
                      beforeUpload={(file: any) => {
                        const isDocx =
                          file.type ===
                            "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
                          file.name.endsWith(".docx");
                        if (!isDocx) {
                          message.error(
                            `${file.name} is not a valid docx file.`
                          );
                          return Upload.LIST_IGNORE;
                        }
                        return false;
                      }}
                      customRequest={handleCustomRequest}
                      onChange={(e) => handleFileChange}
                      fileList={fileList}
                      accept=".docx"
                      className="document-analysis"
                    >
                      <p className="ant-upload-drag-icon">
                        <InboxOutlined style={{ color: "#9B51E0" }} />
                      </p>
                      <p className="ant-upload-text">
                        Drag and drop files here, or click to select files
                      </p>
                      <strong>Word</strong>
                      <p className="ant-upload-hint">Max file size: 5MB</p>
                    </Dragger>
                  </div>
                </div>
              </div>
            </div>
            {uploadProgress > 0 && (
              <Progress percent={uploadProgress} status="active" />
            )}

            {/* <Modal
              title="You have two options to choose from for your files"
              visible={isModalVisible}
              onCancel={handleModalCancel}
              footer={null}
            >
              <p>
                You're about to delete the selected survey permanently. This
                action can't be undone. Are you sure you want to continue?
              </p>
              <div style={{ display: "flex", justifyContent: "space-around" }}>
                <Button
                  type="primary"
                  onClick={() => {
                    handleSignIn();
                    setIsModalVisible(false);
                  }}
                >
                  Select files from Drive
                </Button>
                <Button
                  type="default"
                  onClick={() => {
                    const input = document.createElement("input");
                    input.type = "file";
                    input.accept = ".pdf,.docx";

                    input.onchange = (event: Event) => {
                      const target = event.target as HTMLInputElement;
                      if (target.files && target.files.length > 0) {
                        handleFileUpload({
                          target,
                        } as React.ChangeEvent<HTMLInputElement>);
                      }
                    };

                    input.click();
                    setIsModalVisible(false);
                  }}
                >
                  Select files from computer
                </Button>
              </div>
            </Modal> */}

            <Modal
              title="You have two options to choose from for your files"
              visible={isModalVisible}
              onCancel={handleModalCancel}
              footer={null}
              className="download-modal-style"
              style={{ width: "604px" }}
            >
              <p>
                You're about to delete the selected survey permanently. This
                action can't be undone. Are you sure you want to continue?
              </p>
              <div style={{ display: "flex", justifyContent: "space-around" }}>
                {/* <Button
                  type="primary"
                  onClick={async () => {
                    await handleSignIn(); // Ensure the sign-in happens
                    // Do not close the modal here; keep it open for file selection
                  }}
                >
                  Select files from Drive
                </Button> */}
                <button
                  onClick={() => handleOpenPicker()}
                  className="drive-files-style"
                >
                  Select files from drive
                </button>

                <Button
                  type="default"
                  onClick={() => {
                    const input = document.createElement("input");
                    input.type = "file";
                    input.accept = ".docx";

                    input.onchange = (event: Event) => {
                      const target = event.target as HTMLInputElement;
                      if (target.files && target.files.length > 0) {
                        handleFileUpload({
                          target,
                        } as React.ChangeEvent<HTMLInputElement>);
                      }
                    };

                    input.click(); // This opens the file selection dialog
                    // Keep the modal open to allow multiple selections
                  }}
                  className="mycomputer-files-style"
                >
                  Select files from computer
                </Button>
              </div>

              {/* Display the files from Google Drive */}
              {/* <div style={{ marginTop: "16px" }}>
                <h4>Available files from Google Drive:</h4>
                {files.length > 0 ? (
                  files.map((file: any) => (
                    <Button
                      key={file.uid}
                      onClick={() => {
                        // Set the selected file to the file list
                        setFileList([
                          { uid: file.uid, name: file.name, status: "done" },
                        ]);
                        // Close the modal after file selection
                        setIsModalVisible(false);
                      }}
                    >
                      {file.name}
                    </Button>
                  ))
                ) : (
                  <p>No files found in Google Drive.</p>
                )}
              </div> */}
            </Modal>
          </div>

          <div className="main-content">
            <h3>Text Preprocessing Options</h3>

            <div className="tokenization-content">
              <div className="first-div-style">
                <Form.Item label="Tokenization"></Form.Item>
                <Radio.Group
                  onChange={(e) => setTokenizationType(e.target.value)}
                  value={tokenizationType}
                >
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Tooltip
                      className=""
                      title="Tokenize by word splits text into individual words, treating each word as a separate token for analysis."
                    >
                      <div className="radio-divv">
                        <Radio value="word">Tokenize by word</Radio>
                      </div>
                    </Tooltip>

                    <Tooltip title="Tokenize by sentence splits text into sentences. Each sentence is treated as a separate token for analysis.">
                      <div className="radio-divv">
                        <Radio value="sentence">Tokenize by sentence</Radio>
                      </div>
                    </Tooltip>
                    <Tooltip title="Custom delimiter allows you to split text based on a delimiter you define, such as commas or semicolons.">
                      <div className="radio-divv">
                        <Radio value="custom">Custom delimiter</Radio>
                      </div>
                    </Tooltip>
                  </div>
                </Radio.Group>
                {tokenizationType === "custom" && (
                  <div
                    style={{
                      background: "#FCF3FF",
                      padding: "1rem",
                      marginTop: "1rem  ",
                    }}
                  >
                    <h4 className="h4" style={{ marginTop: "unset" }}>
                      Write here your custom delimiter
                    </h4>
                    <TextArea
                      placeholder="Write here..."
                      autoSize={{ minRows: 2, maxRows: 20 }}
                    />{" "}
                  </div>
                )}
              </div>
            </div>

            <div className="tokenization-content">
              <h4 className="h4">Choose stemming or lemmatization</h4>
              <div>
                {/* <Radio.Group style={{ display: "flex", gap: "2rem" }}>
                  <Tooltip
                    title="Stemming is the process of reducing words to their base or
root form by removing suffixes."
                  >
                    <div className="radio-divv">
                      <Radio className="custom-radio" value="stemming">
                        Stemming
                      </Radio>
                    </div>
                  </Tooltip>
                  <Tooltip
                    title="Lemmatization reduces words to their base form, 
considering their meaning."
                  >
                    <div className="radio-divv">
                      <Radio className="custom-radio" value="lemmatization">
                        Lemmatization
                      </Radio>
                    </div>
                  </Tooltip>
                </Radio.Group> */}
                <Radio.Group
                  style={{ display: "flex", gap: "2rem" }}
                  onChange={(e) => setStemOrLemmatize(e.target.value)}
                  value={stemOrLemmatize} // Bind this state to the value
                >
                  <Tooltip title="Stemming is the process of reducing words to their base form by removing suffixes.">
                    <div className="radio-divv">
                      <Radio className="custom-radio" value="stemming">
                        Stemming
                      </Radio>
                    </div>
                  </Tooltip>
                  <Tooltip title="Lemmatization reduces words to their base form, considering their meaning.">
                    <div className="radio-divv">
                      <Radio className="custom-radio" value="lemmatization">
                        Lemmatization
                      </Radio>
                    </div>
                  </Tooltip>
                </Radio.Group>
              </div>
            </div>

            <div className="tokenization-content">
              <h4 className="h4">Stop words removal</h4>
              <Radio.Group
                onChange={(e) =>
                  setStopWordsEnabled(e.target.value === "enable")
                }
                value={stopWordsEnabled ? "enable" : "disable"}
              >
                <div className="radio-divv">
                  <Radio value="enable">Enable stop word removal</Radio>
                </div>
              </Radio.Group>
              {stopWordsEnabled && (
                <div
                  style={{
                    background: "#FCF3FF",
                    padding: "1rem",
                    marginTop: "1rem  ",
                  }}
                >
                  <h4 className="h4" style={{ marginTop: "unset" }}>
                    Write here if enabled stop words
                  </h4>
                  <TextArea
                    placeholder="Write here if enabled stop words.."
                    autoSize={{ minRows: 2, maxRows: 20 }}
                  />{" "}
                </div>
              )}
            </div>
            <div
              style={{ display: "flex", justifyContent: "center", gap: "1rem" }}
            >
              <button onClick={handleCancel} className="cancelButtonStyle">
                Cancel
              </button>
              <button
                onClick={handleProcessClick}
                className="processButtonStyle"
              >
                {loading ? <Spin /> : "Process"}
              </button>{" "}
            </div>
          </div>

          {/* Modal for Download */}
          <Modal
            visible={isDownloadModalVisible}
            onCancel={handleDownloadModalCancel}
            footer={null}
            centered
          >
            <div style={{ textAlign: "center" }}>
              <img
                src={Files}
                alt="Processed"
                style={{ width: "247px", height: "221px" }}
              />
              <h2>Your document is ready!</h2>
              <p>
                Your document has been processed. You can preview or download it
                below:
              </p>
              <div className="preview-download-div">
                <Button
                  href={processedFileURL}
                  target="_blank"
                  style={{ marginRight: "10px" }}
                  onClick={handleOpenPreviewModal}
                  className="prev-button"
                >
                  <EyeOutlined /> Preview
                </Button>
                <Button
                  href={processedFileURL}
                  download="processedFileURL"
                  className="process-button"
                >
                  <DownloadOutlined />
                  Download
                </Button>
              </div>

              <Button
                type="link"
                onClick={handleDownloadModalCancel}
                style={{ marginTop: "20px" }}
                className="go-back-button"
              >
                <ArrowLeftOutlined /> Go back
              </Button>
            </div>
          </Modal>
        </div>

        <Modal
          title="Preview Document"
          visible={isPreviewModalVisible}
          onCancel={handlePreviewModalCancel}
          footer={null}
          width={800}
        >
          {previewURL ? (
            // Use an iframe to preview the document using Google Docs Viewer
            <iframe
              src={previewURL}
              style={{ width: "100%", height: "600px" }}
              frameBorder="0"
              allowFullScreen
            />
          ) : (
            <p>Preview not available for this file type.</p>
          )}
        </Modal>
      </Content>
    </div>
  );
}

export default GoogleDrive;
